// libs
import { connect } from 'react-redux';
import get from 'lodash/get';
// Components
import Shop from './shop';
// actionCreators
import { fetchCatalogUrl } from './api';

export const mapStateToProps = state => ( {
    userIsLaunchAs: get( state, 'user.isLaunchAs', false )
} );

export const mapDispatchToProps = {
    fetchCatalogUrl
};

export default connect( mapStateToProps, mapDispatchToProps )( Shop );
